import { Box, Typography, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { paths } from "../../paths";
import { clientConfig } from "../../awsClientConfig";
import { userProfileData } from "../../Common/profileInfo";
import { fetchQuery } from "../../functions/misc";
import { GetProfileRoles } from "../../queries/getProfileRoles";
import { GetProtectionPlanSubscription } from "../../queries/GetProtectionPlanSubscription";
import { useRoleStore } from "../../store/ProfileStore";
import useEnrollmentStore from "../../store/EnrollmentStore";
import { useState } from "react";
import Loading from "../../Common/Loading";
import referralCompletedImage from '../../assets/referral-free-completed.png';



const EnrollmentCompletedForm = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { setCustomerRole } = useRoleStore();
    const { setProtectionPlanEnrollment } = useEnrollmentStore();

    const onClickHandler = async () => {
        setLoading(true);
        const profileId = await userProfileData();
        const getRoles = await fetchQuery({ ProfileId: profileId }, GetProfileRoles);
        const getSubscription = await fetchQuery({ ProfileId: profileId }, GetProtectionPlanSubscription);
        if (getRoles) {
            setCustomerRole(getRoles.RoleName);
        }

        if (getSubscription) {
            setProtectionPlanEnrollment({
                subscriptionPlan: getSubscription?.ProtectionPlanName,
                subscriptionStatus: getSubscription?.Status,
                enrollmentStatus: '',
            })
        }
        setLoading(false);
        navigate(paths.dashboard.taxShield.reports);
        navigate(0);
    }
    
    
    return (
        <>
        {loading? <Loading />:
        <Box sx={{alignItems: 'flex-center', width: '75%', justifyContent: 'center',
            p: { xs: 2, md: 6, lg: 4 },
            m: { xs: 2, md: 6, lg: 4 }}}>
            <Typography variant="h5" sx={{mb: 2}}>{'Congratulations! Your FREE account is now activated.'}</Typography>
            
                <Box
                    sx={{
                    pt: 3,
                    pb: 3,
                    pl: 0,
                    pr: 0,
                    mt: 2,
                    border: "1px solid var(--mui-palette-divider)",
                    borderRadius: 1,
                    }}
                >
                    <Grid container sx={{marginInlineStart: '2rem'}}>
                        <Grid item md={6} xs={12}>
                        <Typography variant="body2">Welcome to your FREE Optima Tax Shield account, where you’ll receive Optima’s best-in-class <b>Tax ID Theft Alert and Monitoring</b> service.</Typography>
                        <Typography variant="body2"  sx={{color: '#0B85D8', fontWeight: 700, mt:2}}>Your Risk Report is currently being generated. Generally, this takes 2-3 weeks to process.</Typography>
                        <Typography variant="body2" sx={{mt: 2}}>Although your Risk Report isn’t viewable quite yet, we welcome you to click “Continue to Dashboard” below and to review your account details and tools. We’ll email you when your Risk Report is ready and viewable within your dashboard.</Typography>
                        <Typography variant="body2" sx={{mt: 2}}>–The Tax Shield Team</Typography>
                        <Button onClick={onClickHandler} className="option-primary-button mt-2">
                            Continue to Dashboard
                        </Button>
                        </Grid>
                        <Grid item md={6} className="no-display-mobile">
                            <img src={referralCompletedImage} style={{width:'85%', marginTop: '3rem'}}/>
                        </Grid>
                </Grid>
                    
                    {/*
                    <Button
                        onClick={onClickHandler}
                        className="option-primary-button"
                    >
                        Continue to Dashboard
                    </Button>
                    */}
                </Box>
        </Box>
    }
    </>
    );
  }

  export default EnrollmentCompletedForm;
  